"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHistorySipTrunkingPhoneCallModelDirection = void 0;
exports.ConversationHistorySipTrunkingPhoneCallModelDirection = {
    Inbound: "inbound",
    Outbound: "outbound",
};
